const GA_MEASUREMENT_ID = 'G-ME7RBZPN7M';

let loaded = false;

export const loadGoogleAnalytics = () => {
  if (loaded || typeof window === 'undefined') return;
  if (document.querySelector(`script[data-ga-id="${GA_MEASUREMENT_ID}"]`)) {
    loaded = true;
    return;
  }

  window.dataLayer = window.dataLayer || [];
  if (!window.gtag) {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  script.dataset.gaId = GA_MEASUREMENT_ID;
  script.onload = () => {
    window.gtag('js', new Date());
    window.gtag('config', GA_MEASUREMENT_ID, { anonymize_ip: true });
  };
  document.head.appendChild(script);
  loaded = true;
};

export const unloadGoogleAnalytics = () => {
  document
    .querySelectorAll(`script[src*="googletagmanager"], script[data-ga-id]`)
    .forEach((node) => node.remove());

  const cookies = document.cookie.split(';');
  cookies.forEach((cookie) => {
    const name = cookie.split('=')[0].trim();
    if (name.startsWith('_ga') || name.startsWith('_gid') || name.startsWith('_gat')) {
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${window.location.hostname}`;
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
    }
  });

  loaded = false;
  delete window.gtag;
};

export const applyAnalyticsConsent = (analyticsAllowed) => {
  if (analyticsAllowed) {
    loadGoogleAnalytics();
  } else {
    unloadGoogleAnalytics();
  }
};
